export const navLinks = [
  { id: "stories", label: "情感故事" },
  { id: "years", label: "岁月往事" },
  { id: "notes", label: "生活碎碎念" },
  { id: "voices", label: "情感共鸣" },
  { id: "guide", label: "回忆录方法" },
  { id: "faq", label: "常见问题" },
];

export const heroStats = [
  { value: "128", label: "篇已收录故事" },
  { value: "23", label: "个旧时光主题" },
  { value: "1978", label: "最早的记忆年份" },
  { value: "9", label: "年持续书写" },
];

export const featuredStories = [
  {
    title: "母亲的缝纫机",
    excerpt:
      "那台脚踏缝纫机在窗下放了三十年，机身上落过棉絮，也落过她低头时的影子。我总记得半夜里「嗒嗒」的声音，像下雨，又像有人在替我们把日子一节节缝紧。",
    tag: "亲情",
    date: "1978 · 北方小城",
    readMin: 8,
    image:
      "https://readdy.ai/api/search-image?query=Warm%20painterly%20illustration%20of%20a%20grandmother%20old%20treadle%20sewing%20machine%20beside%20a%20bright%20window%20with%20potted%20green%20plants%2C%20afternoon%20sunlight%20streaming%20in%2C%20muted%20amber%20and%20cream%20tones%2C%20nostalgic%20storybook%20style%2C%20quiet%20domestic%20memory%2C%20soft%20texture&width=640&height=420&seq=story-sewing-01&orientation=landscape",
  },
  {
    title: "站台上那盏灯",
    excerpt:
      "父亲送我上大学那个清晨，小站的灯还亮着。火车进站时带起的风把他的衣角吹起来，他站在原地没动，直到那盏灯被甩成一个小小的黄点，融进还没醒来的天光里。",
    tag: "告别",
    date: "1985 · 绿皮火车",
    readMin: 6,
    image:
      "https://readdy.ai/api/search-image?query=Warm%20painterly%20illustration%20of%20a%20small%20rural%20railway%20station%20platform%20at%20golden%20hour%2C%20an%20old%20wooden%20bench%20and%20a%20hanging%20lamp%20glowing%2C%20distant%20soft%20hills%2C%20sepia%20and%20amber%20nostalgic%20tones%2C%20gentle%20painterly%20texture%2C%20evocative%20memory%20scene&width=640&height=420&seq=story-station-02&orientation=landscape",
  },
  {
    title: "一只怀表走过的时间",
    excerpt:
      "爷爷的怀表停在三点零七分，再没上过弦。后来我才知道，那是他最后一次从田里回来的时刻。表盘上的褪色划痕，比任何相册都更诚实地记着一个人走过的路。",
    tag: "旧物",
    date: "1992 · 老屋抽屉",
    readMin: 7,
    image:
      "https://readdy.ai/api/search-image?query=Warm%20painterly%20illustration%20of%20a%20handwritten%20letter%20and%20an%20old%20brass%20pocket%20watch%20resting%20on%20a%20worn%20wooden%20table%2C%20warm%20lamp%20light%2C%20cream%20background%2C%20nostalgic%20memoir%20tone%2C%20editorial%20still%20life%2C%20soft%20shadows&width=640&height=420&seq=story-watch-03&orientation=landscape",
  },
  {
    title: "夏夜阳台上的茉莉",
    excerpt:
      "没有空调的那些年，我们搬着竹床睡在阳台上，母亲摇着蒲扇数星星。茉莉花开时整条巷子都是甜的，如今住在有玻璃幕墙的楼里，我却再没闻过那么清楚的香气。",
    tag: "四季",
    date: "1999 · 老居民楼",
    readMin: 5,
    image:
      "https://readdy.ai/api/search-image?query=Warm%20painterly%20illustration%20of%20a%20summer%20evening%20balcony%20with%20laundry%20lines%20and%20potted%20jasmine%20flowers%2C%20soft%20lantern%20light%2C%20warm%20terracotta%20and%20cream%20tones%2C%20gentle%20nostalgic%20mood%2C%20storybook%20style%2C%20cozy%20dusk&width=640&height=420&seq=story-jasmine-04&orientation=landscape",
  },
  {
    title: "巷口那辆二八大杠",
    excerpt:
      "父亲的那辆二八大杠，横梁上坐过我，后座上驮过米，冬天还绑过一整棵白菜。它锈迹斑斑地被锁在墙边十年，像一位不好意思退休的老伙计，还在等一句「走吧」。",
    tag: "故乡",
    date: "2005 · 老巷口",
    readMin: 6,
    image:
      "https://readdy.ai/api/search-image?query=Warm%20painterly%20illustration%20of%20an%20old%20bicycle%20leaning%20against%20a%20whitewashed%20wall%20with%20climbing%20roses%2C%20soft%20morning%20light%2C%20cream%20and%20warm%20pink%20tones%2C%20nostalgic%20small%20town%20memory%2C%20editorial%20illustration&width=640&height=420&seq=story-bicycle-05&orientation=landscape",
  },
  {
    title: "灶台上的一口铜锅",
    excerpt:
      "奶奶说，家里再难，这口锅也没空过。冬天炖萝卜，秋天煮新米，年三十的饺子在锅里翻着白肚皮。如今锅底磨得发亮，像被岁月反复擦过的镜子，照见的都是团圆。",
    tag: "团圆",
    date: "2013 · 老灶间",
    readMin: 7,
    image:
      "https://readdy.ai/api/search-image?query=Warm%20painterly%20illustration%20of%20a%20rustic%20kitchen%20with%20steaming%20bowls%20and%20a%20shining%20copper%20pot%2C%20warm%20firelight%2C%20cream%20and%20amber%20palette%2C%20cozy%20nostalgic%20domestic%20scene%2C%20storybook%20style%2C%20soft%20glow&width=640&height=420&seq=story-pot-06&orientation=landscape",
  },
];

export const yearMemories = [
  {
    year: "1978",
    title: "麦田与蝉鸣",
    text:
      "包产到户的头一年，家家都往地里多使了力。夏收时大人在前头割麦，小孩在后头拾穗，蝉声把整个下午拉得很长，长到像永远不会结束。",
    tag: "土地",
  },
  {
    year: "1985",
    title: "第一封家书",
    text:
      "出门打工的人开始往家里寄信。母亲不识几个字，却把每一封都叠得整整齐齐压在枕头下，说字是凉的，压在身下就暖了。",
    tag: "牵挂",
  },
  {
    year: "1992",
    title: "收音机里的点歌",
    text:
      "下午五点半，巷子里好几台收音机同时响起来。谁家有点喜事就花钱点一首歌，整条街的人一起听，那是最早的「直播」。",
    tag: "声音",
  },
  {
    year: "1999",
    title: "录像厅的冬天",
    text:
      "五毛钱能坐一下午，屏幕上是雪花点也看得津津有味。散场时天已经黑透，呼出的白气在路灯下散开，像给青春加了一层滤镜。",
    tag: "青春",
  },
  {
    year: "2005",
    title: "搬进有电梯的楼",
    text:
      "从六层的老楼搬进带电梯的新居，全家最高兴的是搬煤球的活终于不用干了。可夜深时，母亲还是会说，楼上安静得有点不像家。",
    tag: "变迁",
  },
  {
    year: "2013",
    title: "第一张全家福手机照",
    text:
      "智能手机进了家门，年夜饭前有人喊「都凑过来」，于是有了第一张随手拍的全家福。画质糊了，笑声却比任何一年都清楚。",
    tag: "团圆",
  },
  {
    year: "2020",
    title: "隔着屏幕的年夜饭",
    text:
      "那一年的团圆是一桌菜对着几个屏幕。大家举着筷子对着摄像头碰杯，谁都没说想念，可挂断之后，屋子里安静了很久很久。",
    tag: "思念",
  },
];

export const noteTags = ["全部", "亲情", "旧物", "故乡", "独处", "四季", "告别"];

export const lifeNotes = [
  {
    tag: "亲情",
    title: "父亲第一次打来电话",
    text:
      "他从来只发短信，那天却突然打来，说就想听听你声音。两分钟后匆匆挂断，后来我才知道，他是站在墓园里，替奶奶转一句话。",
  },
  {
    tag: "故乡",
    title: "老屋门口那棵香椿",
    text:
      "春天一到，邻居们就端着长竿子来掐香椿芽。一栋楼的人共用一棵树的滋味，如今小区里种满观赏花，谁也不认识谁。",
  },
  {
    tag: "旧物",
    title: "抽屉里的一沓信纸",
    text:
      "泛黄的信纸上还留着蓝墨水的气味。当年的每一次落笔都要斟酌半天，不像现在，删掉只要一秒钟，于是什么都留不下。",
  },
  {
    tag: "独处",
    title: "一个人住的第七百天",
    text:
      "学会了给自己做一顿像样的饭，也学会了在傍晚把灯全部打开。自洽原来是件慢慢的事，像晾在阳台上的毛巾，风干得无声无息。",
  },
  {
    tag: "四季",
    title: "立秋那天的一场雨",
    text:
      "雨来得没头没尾，把蝉声浇灭了一半。我忽然发现，季节的转折从来不发通知，只是某个傍晚，风忽然有了凉意。",
  },
  {
    tag: "告别",
    title: "把旧衣服送走",
    text:
      "整理衣柜时迟迟下不了手，衣柜里挂着的不是衣服，是那个还年轻、还爱穿亮色、还对明天充满指望的自己。",
  },
  {
    tag: "亲情",
    title: "母亲的手机相册",
    text:
      "教她用智能手机那年，她把我的照片存了两百多张，很多是重复的截屏。对她来说，拍不清楚也好，只要里面有我。",
  },
  {
    tag: "独处",
    title: "深夜厨房的一碗面",
    text:
      "加班回来给自己煮碗阳春面，葱花在热气里打个转。那一刻忽然明白，所谓踏实，不过是有人、有灯、有一口热的东西等你。",
  },
  {
    tag: "故乡",
    title: "回不去的公交站名",
    text:
      "老城区改造后，那条线路的站名全换了。我偶尔还会报出旧站名问路，对方愣一下，然后说，那地方早就没有了。",
  },
];

export const readerVoices = [
  {
    quote: "读到缝纫机那一篇时，我一下想起了外婆屋里的那台，连落灰的位置都一样。谢谢你替我们这些不会写字的人，把记忆留了下来。",
    name: "林知夏",
    meta: "读者 · 杭州",
  },
  {
    quote: "长日光阴这个名字起得真好。看完会想给很久没联系的家里人打个电话，这种被轻轻推一把的感觉，很久没有过了。",
    name: "周叙",
    meta: "读者 · 成都",
  },
  {
    quote: "我不是喜欢怀旧的人，但这里写的是具体的、有温度的事，不是空泛的感慨。看完像是陪作者把一段路重新走了一遍。",
    name: "陈默",
    meta: "读者 · 广州",
  },
  {
    quote: "每篇都不长，适合睡前读。合上手机的时候心里是安稳的，好像那些被时间冲淡的东西，又被轻轻捞了回来。",
    name: "苏念",
    meta: "读者 · 西安",
  },
];

export const memoirThemes = [
  {
    icon: "ri-home-heart-line",
    title: "家人的日常",
    desc: "父母、长辈、老屋里的琐碎。写他们不是写传奇，而是写他们如何把普通的日子过得郑重。",
  },
  {
    icon: "ri-map-pin-time-line",
    title: "故乡与地标",
    desc: "一条巷子、一个车站、一棵树。地方会被拆掉，但写下来，它就永远留在地图上。",
  },
  {
    icon: "ri-gift-2-line",
    title: "旧物与手作",
    desc: "怀表、缝纫机、搪瓷缸。物件是记忆的容器，摸得到的情感比形容词更牢。",
  },
  {
    icon: "ri-sun-cloudy-line",
    title: "四季与天气",
    desc: "第一场雪、立秋的雨、夏天的晚风。季节是所有人共享的时钟，也最容易唤起共鸣。",
  },
  {
    icon: "ri-emotion-sad-line",
    title: "告别与遗憾",
    desc: "来不及说的话、没能赴的约。写出来不是揭伤疤，而是给情绪一个体面的去处。",
  },
  {
    icon: "ri-heart-3-line",
    title: "小小的欢喜",
    desc: "一碗面、一句关心、一次久别重逢。温暖常常藏在很小的地方，需要我们低头去看。",
  },
];

export const guideSteps = [
  {
    step: "01",
    title: "先写一个具体的画面",
    text:
      "不要从「我小时候很幸福」开始，而是写「夏天傍晚，母亲把竹床搬到阳台上，蒲扇风里有茉莉的味道」。具体的画面自带情绪。",
  },
  {
    step: "02",
    title: "抓住一个物件或地点",
    text:
      "旧物和地标是最好的钩子。挑一件你舍不得扔的东西，把它放在窗前，写它在你记忆里出现过的所有时刻。",
  },
  {
    step: "03",
    title: "只写一件事，写透它",
    text:
      "回忆录最容易犯的错是贪多。一篇文章只讲一个瞬间，把它放大、写慢，让读者在里面待得久一点。",
  },
  {
    step: "04",
    title: "留一句没说出口的话",
    text:
      "好的回忆通常带着一点点意犹未尽。结尾不必总结升华，留一句当时没说出口的话，反而最动人。",
  },
];

export const faqs = [
  {
    q: "没有写作经验，也能写下自己的回忆吗？",
    a: "完全可以。这里的大多数故事都来自普通人的随手记录，不需要文采，只需要一个你真正在意的画面。从今天的一件小事写起，往往比硬想「难忘的往事」更容易写下去。",
  },
  {
    q: "回忆记不清细节了，还能写吗？",
    a: "记忆本就模糊，写作不是还原事实，而是诚实地记录「你记得的样子」。闻到什么味、当时什么天气、心里什么感觉，这些模糊的部分恰恰是最真实的。",
  },
  {
    q: "这里的故事会一直更新吗？",
    a: "会。长日光阴按「情感故事」「岁月往事」「生活碎碎念」三条线持续收集，订阅之后，新的回忆录会不定期送达你的邮箱。",
  },
  {
    q: "写下来的东西会给别人看吗？",
    a: "是否公开完全由你决定。你可以把它当作只写给自己的信，也可以选择分享给家人。在这里，书写本身比被谁读到更重要。",
  },
  {
    q: "适合什么时间阅读这些故事？",
    a: "很多人喜欢在睡前读一两篇，篇幅都不长。也有人把它当作通勤路上的陪伴。找一个安静的时候，让旧时光慢慢展开就好。",
  },
  {
    q: "想把自己的故事投稿，可以吗？",
    a: "可以。订阅之后你会收到回复方式，我们会认真读完每一篇。被选中的故事会以小栏目的形式出现在长日光阴里，并保留你的署名。",
  },
];